import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import Autocomplete from "@mui/material/Autocomplete";
import { AgentPublicBio } from "model/agent";
import { MarketResource } from "api/resource/market";
import * as sharedStyles from "../styles";
import { styles } from "./styles";

// Force the options dropdown to open downward instead of flipping above the field.
const BottomPopper = (props: any) => (
	<Mui.Popper {...props} placement="bottom-start" modifiers={{ flip: { enabled: false } }} />
);

interface OwnProps {
	publicBio: AgentPublicBio;
	markets: MarketResource[];
	onUpdateField: <K extends keyof AgentPublicBio>(
		field: K,
		value: AgentPublicBio[K],
	) => void;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

class Component extends React.Component<Props> {
	private handleChange = (
		_event: React.ChangeEvent<{}>,
		value: MarketResource[],
	) => {
		this.props.onUpdateField("markets", value.map((m) => m.id));
	};

	public render() {
		const { publicBio, markets, classes = {} } = this.props;

		const selectedMarketIds = publicBio.markets ?? [];
		const selectedMarkets = selectedMarketIds
			.map((id) => markets.find((m) => m.id === id))
			.filter(Boolean) as MarketResource[];

		return (
			<>
				<Mui.Grid item xs={12}>
					<Mui.Typography style={sharedStyles.sectionTitleWithDescription}>Markets</Mui.Typography>
					<Mui.Typography style={sharedStyles.descriptionText}>
						Select the markets you serve to display on your public profile. If no markets appear, contact your account administrator to have them created.
					</Mui.Typography>
				</Mui.Grid>

				<Mui.Grid item xs={12}>
					<Mui.Typography variant="body2" gutterBottom style={sharedStyles.fieldLabel}>
						Markets
					</Mui.Typography>
					<Autocomplete
						multiple
						disableCloseOnSelect
						options={markets}
						getOptionLabel={(option) => option.name}
						value={selectedMarkets}
						onChange={this.handleChange}
						size="small"
						PopperComponent={BottomPopper}
						renderOption={(props, option, { selected }) => (
							<li {...props}>
								<Mui.Checkbox
									color="secondary"
									checked={selected}
									size="small"
								/>
								{option.name}
							</li>
						)}
						renderTags={(selected, getTagProps) =>
							selected.map((market, index) => (
								<Mui.Chip
									{...getTagProps({ index })}
									key={market.id}
									label={market.name}
									deleteIcon={<Icons.X size={16} />}
									className={classes.marketChip}
								/>
							))
						}
						renderInput={(params) => (
							<Mui.TextField
								{...params}
								variant="outlined"
								placeholder="Select markets..."
							/>
						)}
						noOptionsText="No markets available"
					/>
				</Mui.Grid>
			</>
		);
	}
}

export const MarketsSection = withStyles(Component, styles);
